import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext } from 'react';
import TextButton from '../../../Buttons/TextButton';
import omit from 'lodash/omit';
import { useDropdownToggleProps } from '../../hooks/useDropdownToggleProps';
import { DropdownStateContext } from '../../DropdownStateManager';
function usePostfixIcon({ postfix }) {
    const { isOpen } = useContext(DropdownStateContext);
    if (postfix && postfix.opened) {
        return isOpen ? postfix.opened : postfix.closed;
    }
    return postfix;
}
/**
 * A wrapper around our DS `TextButton` that provides the props for a dropdown toggle.
 *
 * Note: This component is only the toggle! It doesn't contain a popover or dropdown. If you're looking for something that does,
 * you probably want a preset instead of this. Consider `TextButtonWithContextMenu`.
 *
 * Required contexts: `PopperDropdownContext`, `DropdownStateContext`
 */ const PopperTextToggleButton = (props)=>{
    const necessaryToggleProps = useDropdownToggleProps();
    const postfixIcon = usePostfixIcon(props);
    return /*#__PURE__*/ React.createElement(TextButton, _object_spread({
        postfix: postfixIcon
    }, necessaryToggleProps, omit(props, 'postfix')));
};
PopperTextToggleButton.displayName = 'PopperTextToggleButton';
export default PopperTextToggleButton;
